<template>
  <v-container class="pt-0" style="height: 100%; background-color: #ffffff">
    <v-row
      ><v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          :text="
            forCreatedBy == 'admin'
              ? 'menuInformationCenterFull'
              : 'menuRequest'
          "
          :redirect_name="redirect_name"
        />
      </v-col>
    </v-row>

    <v-row class="px-2 mt-2">
      <v-col cols="12" class="py-1 mt-1" style="height: fit-content">
        <div class="d-flex justify-space-between" style="gap: 4px">
          <p
            class="text-start mb-0 pb-0 font-weight-bold"
            style="font-size: 20px; word-break: break-word; line-height: 1.3"
          >
            {{ dataItem.title }}
          </p>
          <div
            v-if="forCreatedBy == 'employee' && dataItem.report_status_id"
            class="d-flex justify-end"
          >
            <v-chip
              class="font-weight-bold"
              :color="dataItem.report_status_color"
              dark
              small
            >
              {{ dataItem.report_status_name }}
            </v-chip>
          </div>
        </div>
        <p
          v-if="dataItem.sub_title"
          class="text-start mb-0 pb-0 grey--text text--darken-1 pt-1"
          style="font-size: 16px"
        >
          {{ dataItem.sub_title }}
        </p>
        <div class="d-flex align-center my-2">
          <!-- Created At -->
          <div
            class="d-flex align-center px-2 py-0 mr-2"
            style="
              height: 24px;
              gap: 4px;
              border: 1px solid #e0e0e0;
              border-radius: 8px;
            "
          >
            <v-icon small color="#757575">mdi-calendar</v-icon>
            <div style="color: #757575; font-size: 12px">
              {{ dataItem.created_at | formatDate }}
            </div>
          </div>
          <v-chip v-if="dataItem.report_type_name" small>{{
            dataItem.report_type_name
          }}</v-chip>
        </div>

        <!-- // ========== ========== Schema Report Type ========== ========== -->
        <div v-if="dataItem.schema_detail" class="my-2">
          <div
            class="mb-1"
            style="font-weight: 500; text-decoration: underline"
          >
            {{ $t("textForm") }}
          </div>
          <div>
            <div
              v-for="(item, index) in reportTypeSchemaFlat"
              :key="index"
              class="d-flex mb-1"
            >
              <div class="mr-2" style="max-width: 50%">
                {{ formatMyQuestion(item.name) }} :
              </div>
              <div>
                <!-- Image -->
                <div
                  v-if="checkTypeMyQuestion(item.name) === 'image'"
                  class="d-flex flex-wrap"
                  style="gap: 8px"
                >
                  <img
                    v-for="(itemImage, i) in formatMyDetail(item.name)"
                    :key="i"
                    style="
                      width: 100%;
                      max-width: fit-content;
                      max-height: 120px;
                      object-fit: contain;
                      border-radius: 4px;
                    "
                    :src="itemImage.content"
                    @click="handleClickPreviewFormQuestion(itemImage)"
                  />
                </div>
                <!-- Text -->
                <div
                  v-else-if="checkTypeMyQuestion(item.name) === 'text'"
                  style="font-size: 16px; white-space: pre-line"
                >
                  {{ formatMyDetail(item.name) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataItem.detail">
          <div
            class="mb-1"
            style="font-weight: 500; text-decoration: underline"
          >
            Detail
          </div>
          <p
            class="text-start mb-0 pb-0 pt-1 ql-editor"
            style="color: initial; height: fit-content"
            v-html="formatHtmlDetail(dataItem.detail)"
          ></p>
        </div>

        <div v-if="dataItem.report_files.length > 0" class="mt-2">
          <div class="black--text label-attachment">
            {{
              $t("textAttachmentCount", { count: dataItem.report_files.length })
            }}
          </div>
          <div
            v-for="(item, index) in dataItem.report_files"
            :key="index"
            class="my-2 d-flex pa-2 align-center attachment-box"
            @click="handleClickPreview(item)"
          >
            <v-icon class="mr-2">mdi-file-check-outline</v-icon>
            <div style="word-break: break-all">
              {{ item.name }}
            </div>
            <v-btn icon @click="handleClickDownload($event, item)">
              <v-icon color="blue">mdi-download-outline</v-icon>
            </v-btn>
          </div>
        </div>
        <DialogPreviewFile
          :dialogOpen="filePreview.dialog"
          :fileUrl="filePreview.url"
          :fileName="filePreview.name"
          @onClose="handleClosePreview"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6"><v-divider></v-divider></v-row>

    <!-- ========== ========== Comment ========== ========== -->
    <v-row class="px-2 mt-2">
      <v-col
        cols="12"
        class="py-1 mt-1"
        :style="{
          'margin-bottom': dataItem.is_employee_comment ? '280px' : '',
        }"
      >
        <v-card elevation="0" rounded="lg">
          <v-card-text class="px-0">
            <CommentListView
              ref="refCommentListView"
              :reportId="reportId"
              :isEmployeeComment="dataItem.is_employee_comment"
              @onClickReplyComment="handleClickReplyComment"
              @onClickPreviewFile="handleClickPreview"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ========== ========== Input Comment ========== ========== -->
    <v-footer
      v-if="
        dataItem.is_employee_comment && checkReportAdminStatusComment(dataItem)
      "
      fixed
      padless
      color="white"
      elevation="4"
    >
      <v-container>
        <v-row class="px-4 pt-2 pb-4">
          <v-col
            v-if="replyCommentDetail.id"
            cols="12"
            class="d-flex px-0 py-0 align-center"
          >
            <div class="mr-2 grey--text text--darken-1">
              {{ $t("textReply") }}
            </div>
            <v-avatar size="48" color="#E0E0E0">
              <v-img
                :src="
                  replyCommentDetail.profile_path
                    ? replyCommentDetail.profile_path
                    : defaultImage
                "
              ></v-img>
            </v-avatar>
            <div class="label-name ml-2">{{ replyCommentDetail.fullname }}</div>
            <v-btn class="ml-2" icon @click="handleClearReplyComment">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-flex px-0">
            <v-avatar size="48" color="#E0E0E0" style="min-width: 48px">
              <v-img
                :src="customer.image ? customer.image : defaultImage"
              ></v-img>
            </v-avatar>
            <div class="ml-2" style="width: calc(100% - 56px)">
              <v-textarea
                class="fixed-border-textarea"
                :placeholder="$t('textInputComment') + '*'"
                v-model="inputComment"
                outlined
                dense
                hide-details
                no-resize
                rows="2"
                auto-grow
                style="font-size: 16px"
                maxlength="640"
              />
              <div class="mt-2 d-flex">
                <div
                  v-if="
                    replyCommentDetail.id &&
                    replyCommentDetail.report_comment_schema_id
                  "
                  class="mr-2"
                >
                  <v-btn
                    class="px-1"
                    small
                    @click="handleOpenCommentSchemaDetail"
                  >
                    <v-icon class="mr-2" small
                      >mdi-file-document-edit-outline</v-icon
                    >
                    {{ $t("textFillInForm") }}
                    <v-icon
                      class="ml-2"
                      small
                      :color="
                        reportCommentSchemaDetail.schema_detail
                          ? 'green'
                          : 'red'
                      "
                      >{{
                        reportCommentSchemaDetail.schema_detail
                          ? "mdi-check-decagram-outline"
                          : "mdi-alert-decagram-outline"
                      }}</v-icon
                    >
                  </v-btn>
                  <DialogReportCommentSchemaDetail
                    :dialogOpen="dialogCommentSchemaDetail"
                    :editedItem="reportCommentSchemaDetail"
                    @onClose="handleCloseCommentSchemaDetail"
                    @onSave="handleSaveCommentSchemaDetail"
                  />
                </div>
                <div>
                  <v-btn
                    v-if="dataItem.is_employee_comment_attachment"
                    class="px-1"
                    small
                    @click="dialogCommentReportFile = true"
                  >
                    <v-icon
                      small
                      color="#757575"
                      style="transform: rotate(-90deg)"
                      >mdi-attachment</v-icon
                    >
                    {{ $t("textAttachmentFile") }}
                    {{
                      commentReportFiles.length > 0
                        ? `(${commentReportFiles.length})`
                        : ""
                    }}
                  </v-btn>
                  <div
                    v-if="errorFileSize"
                    class="mt-1"
                    style="color: #f44336; font-size: 12px"
                  >
                    {{
                      $t("errorUploadLimitFileSize", {
                        fileLimitMB: fileLimitMB,
                      })
                    }}
                  </div>
                </div>
              </div>
            </div>

            <!-- ========== ========== Dialog Select File ========== ========== -->
            <v-dialog
              v-model="dialogCommentReportFile"
              persistent
              max-width="840px"
            >
              <v-card>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t("textAttachmentFile")
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="dialogCommentReportFile = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-card-text class="px-4 pt-0 pb-2">
                  <div>
                    <v-file-input
                      ref="inputReportFile"
                      v-model="inputReportFile"
                      accept="image/*, video/*, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      color="deep-purple accent-4"
                      dense
                      hide-details
                      multiple
                      :disabled="commentReportFiles.length == 5"
                      :placeholder="labelSelectFile"
                      @change="selectFile"
                    >
                    </v-file-input>
                    <div class="mt-2">
                      {{
                        $t("hintUploadMultiFile", {
                          fileLimit: fileLimit,
                          fileLimitMB: fileLimitMB,
                        })
                      }}
                    </div>
                    <div
                      v-if="errorFileSize"
                      class="mb-1"
                      style="color: #f44336"
                    >
                      {{
                        $t("errorUploadLimitFileSize", {
                          fileLimitMB: fileLimitMB,
                        })
                      }}
                    </div>
                  </div>
                  <div class="mt-6">
                    <div
                      v-for="(item, index) in commentReportFiles"
                      :key="index"
                      class="my-2 d-flex pa-2 align-center"
                      style="border: 1px solid #9e9e9e; border-radius: 8px"
                    >
                      <v-icon class="mr-2">mdi-file-check-outline</v-icon>
                      <div style="word-break: break-word">
                        {{ item.name }}
                      </div>
                      <div class="ml-2">
                        {{ item.size | fileSize }}
                      </div>
                      <v-icon
                        class="mr-0 ml-auto"
                        @click="deleteFile(item)"
                        color="red"
                      >
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
            <!-- ========== ========== ========== ========== -->
          </v-col>
          <v-col cols="12" class="d-flex justify-end px-0 py-0">
            <v-btn
              dark
              :disabled="disablePost ? true : false"
              :style="{
                'background-color': disablePost ? '#EEEEEE !important' : '',
                color: disablePost ? '#9E9E9E !important' : '',
              }"
              @click="handlePostComment"
              >{{ $t("textPost") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import Axios from "@/config/customer-service";
import moment from "moment";
import CommentListView from "../../../components/reportAdminUser/comment-list-view.vue";
import DialogPreviewFile from "../../../components/dialog-preview-file.vue";
import _ from "lodash";
import {
  checkTypeQuestion,
  formatDetail,
  formatFlatQuestion,
  formatHtmlDetailDefault,
  formatQuestion,
} from "../../../config/general-function";
import DialogReportCommentSchemaDetail from "../../../components/reportAdminUser/dialog-report-comment-schema-detail.vue";

export default {
  inject: ["isAppLoading"],
  emits: ["onClick"],
  components: {
    HeaderTextBg,
    CommentListView,
    DialogPreviewFile,
    DialogReportCommentSchemaDetail,
  },

  data() {
    return {
      reportId: null,
      dataItem: {
        id: null,
        title: "",
        sub_title: "",
        detail: "",
        schema_detail: "",
        report_type_id: "",
        report_type_name: "",
        report_type_schema: null,
        report_status_id: "",
        report_status_name: "",
        report_status_color: "",
        created_at: null,
        is_employee_comment: false,
        receiver_permission: null,
        report_files: [],
      },

      reportTypeSchema: null,
      reportTypeSchemaFlat: [],

      replyCommentDetail: {
        id: null,
        fullname: null,
        profile_path: null,
        report_comment_schema_id: null,
      },
      inputComment: "",
      commentReportFiles: [],
      dialogCommentSchemaDetail: false,
      reportCommentSchemaDetail: {
        schema_label: null,
        schema: null,
        schema_detail: null,
      },

      filePreview: {
        dialog: false,
        url: "",
        name: "",
        description: "",
      },

      forCreatedBy: "admin",
      listStatus: [],

      dialogCommentReportFile: false,
      inputReportFile: null,
      errorFileSize: false,
      fileLimit: 5,
      fileLimitMB: 40,

      redirect_name: "",
      previousRouteName: null,
      queryPreviousRouteName: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    this.reportId = this.$route.params?.id || null;
    this.queryPreviousRouteName = this.$route.query.prev_route_name || null;
    this.getListStatus();
    await this.getReportAdminDetail();
    // ========== ========== ========== ==========
    if (!this.previousRouteName) {
      this.redirect_name =
        this.forCreatedBy == "admin"
          ? "information-center-list"
          : "request-list";
    } else {
      this.redirect_name = "";
    }
    if (this.queryPreviousRouteName) {
      this.redirect_name = this.queryPreviousRouteName;
    }
  },
  methods: {
    checkReportAdminStatusComment(param) {
      let check = true;
      const model = this.listStatus.find((x) => x.id == param.report_status_id);
      if (model?.type && ["completed", "canceled"].includes(model.type)) {
        check = false;
      }
      return check;
    },

    // ========== ========== Form ========== ==========
    formatMyQuestion(question) {
      return formatQuestion(question, this.reportTypeSchema);
    },
    formatMyDetail(question) {
      return formatDetail(
        this.dataItem.schema_detail[question],
        question,
        this.reportTypeSchema
      );
    },
    checkTypeMyQuestion(question) {
      return checkTypeQuestion(question, this.reportTypeSchema);
    },
    handleClickPreviewFormQuestion(param) {
      this.filePreview.url = param.content;
      this.filePreview.name = param.name;
      this.filePreview.dialog = true;
    },
    // ========== ========== ========== ==========

    async getListStatus() {
      try {
        const response = await Axios.get(`/report-admin/getListReportStatus`);
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse?.data || [];
          this.listStatus = [...data];
        }
      } catch (err) {
        console.log("getListStatus", err);
      }
    },
    async getReportAdminDetail() {
      try {
        let response = await Axios.get(
          `/report-admin/getReportAdminDetail/${this.reportId}`
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          let fetchData = dataResponse.data;
          this.dataItem = { ...fetchData };
          if (this.dataItem.create_by_employee_id) {
            this.forCreatedBy = "employee";
          }
          if (this.dataItem.report_type_schema) {
            this.reportTypeSchema = this.dataItem.report_type_schema;
            this.reportTypeSchemaFlat = formatFlatQuestion(
              this.reportTypeSchema
            );
          }
        } else {
          const targetRoute = this.$router.resolve({
            name: "main",
          });
          window.location.href = targetRoute.href;
        }
      } catch (err) {
        console.log("getReportAdminDetail", err);
        this.$swal
          .fire({
            icon: "error",
            title: JSON.stringify(err?.response?.data),
            showConfirmButton: false,
            timer: 3000,
          })
          .then(() => {
            const targetRoute = this.$router.resolve({
              name: "main",
            });
            window.location.href = targetRoute.href;
          });
      }
    },

    // ========== ========== Comment ========== ==========
    handleClickReplyComment(param) {
      this.replyCommentDetail = { ...param };
      if (this.replyCommentDetail.report_comment_schema_id) {
        this.reportCommentSchemaDetail = {
          schema_label: this.replyCommentDetail.schema_label || null,
          schema: this.replyCommentDetail.schema || null,
          schema_detail: null,
        };
      } else {
        this.reportCommentSchemaDetail = {
          schema_label: null,
          schema: null,
          schema_detail: null,
        };
      }
    },
    handleClearReplyComment() {
      this.replyCommentDetail = {
        id: null,
        fullname: null,
        profile_path: null,
        report_comment_schema_id: null,
      };
      this.reportCommentSchemaDetail = {
        schema_label: null,
        schema: null,
        schema_detail: null,
      };
      if (this.$refs.refCommentListView) {
        this.$refs.refCommentListView.handleClearReplyComment();
      }
    },
    async handlePostComment() {
      if (this.errorFileSize) {
        return;
      }
      this.isAppLoading(true);
      try {
        const body = {
          report_id: this.reportId,
          comment: this.inputComment || null,
          comment_id: this.replyCommentDetail.id || null,
          report_files: this.commentReportFiles || null,
          report_comment_schema_id: null,
          schema_detail: this.reportCommentSchemaDetail.schema_detail || null,
        };
        const data = _.cloneDeep(body);
        const formData = new FormData();
        for (let key in data) {
          const value = data[key];
          if (value) {
            if (typeof value == "object") {
              if (Array.isArray(value)) {
                if (value.length == 0) {
                  formData.append(key, "");
                } else if (key == "report_files") {
                  const id = value.filter((x) => !x.file).map((x) => x.id);
                  if (id.length > 0) {
                    formData.append("report_files_id", JSON.stringify(id));
                  }
                  const file = value.filter((x) => x.file).map((x) => x.file);
                  if (file.length > 0) {
                    for (let item of file) {
                      formData.append("report_files[]", item);
                    }
                  }
                }
              } else {
                formData.append(key, JSON.stringify(value));
              }
            } else {
              formData.append(key, data[key]);
            }
          } else {
            formData.append(key, "");
          }
        }
        // ========== ========== ========== ==========
        let response = await Axios.post(
          `/report-admin/postReportAdminComment/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          if (this.$refs.refCommentListView) {
            const data = dataResponse.data;
            if (this.replyCommentDetail.id) {
              this.$refs.refCommentListView.handlePostReplyComment(data);
            } else {
              this.$refs.refCommentListView.handlePostComment(data);
            }
          }
          this.inputComment = "";
          this.commentReportFiles = [];
          this.reportCommentSchemaData = {
            id: null,
            name: null,
            label: null,
          };
          this.handleClearReplyComment();
        } else {
          this.$swal.fire({
            icon: "error",
            title: dataResponse.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      } catch (err) {
        console.log("handlePostComment", err);
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
    // Form Reply Comment Schema Detail
    async handleOpenCommentSchemaDetail() {
      this.dialogCommentSchemaDetail = true;
    },
    async handleCloseCommentSchemaDetail() {
      this.dialogCommentSchemaDetail = false;
    },
    async handleSaveCommentSchemaDetail(param) {
      this.reportCommentSchemaDetail.schema_detail = param.schema_detail;
      this.dialogCommentSchemaDetail = false;
    },
    // ========== ========== ========== ==========

    // ========== ========== File ========== ==========
    selectFile(event) {
      for (let [index, item] of event.entries()) {
        const detail = {
          id: `${new Date().getTime()}_${index}`,
          name: item.name,
          size: item.size,
          mime_type: item.type,
          file: item,
        };
        if (this.commentReportFiles.length < this.fileLimit) {
          this.commentReportFiles.push(detail);
        }
      }
      // ========== ========== ========== ==========
      let totalSize = 0;
      for (let item of this.commentReportFiles) {
        totalSize += item.size;
      }
      if (totalSize / 1000000 > this.fileLimitMB) {
        this.errorFileSize = true;
      } else {
        this.errorFileSize = false;
      }
      // ========== ========== ========== ==========
      setTimeout(() => {
        this.inputReportFile = null;
        if (this.$refs.inputReportFile) {
          this.$refs.inputReportFile.reset();
        }
      }, 1000);
    },
    deleteFile(param) {
      this.commentReportFiles = this.commentReportFiles.filter(
        (x) => x.id != param.id
      );
      // ========== ========== ========== ==========
      let totalSize = 0;
      for (let item of this.commentReportFiles) {
        totalSize += item.size;
      }
      let sizeRef = 1000000;
      // sizeRef = 1024 * 1024;
      if (totalSize / sizeRef > this.fileLimitMB) {
        this.errorFileSize = true;
      } else {
        this.errorFileSize = false;
      }
      // ========== ========== ========== ==========
    },

    // ========== ========== ========== ==========
    handleClickPreview(param) {
      this.filePreview.url = param.url;
      this.filePreview.name = param.name;
      this.filePreview.dialog = true;
    },
    handleClosePreview() {
      this.filePreview.dialog = false;
    },
    async handleClickDownload(event, param) {
      event.stopPropagation();
      this.isAppLoading(true);
      try {
        let filename = param.name;
        let response = await fetch(param.url, {
          cache: "no-cache",
        });
        let blob = await response.blob();
        let url = await URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.crossOrigin = "Anonymous";
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
    labelSelectFile() {
      return `${this.$t("textSelectFile")} (${this.$t(
        "textImageType"
      )}, ${this.$t("textVideoType")}, PDF, Excel)`;
    },
    disablePost() {
      let check = true;
      if (this.inputComment) {
        if (this.replyCommentDetail.report_comment_schema_id) {
          if (this.reportCommentSchemaDetail.schema_detail) {
            check = false;
          }
        } else {
          check = false;
        }
      }
      return check;
    },
  },
  watch: {},
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YY, HH:mm");
    },
    fileSize: function (value) {
      let label = "";
      const size = value / 1000000;
      label = `(${size} MB)`;
      return label;
    },
  },
};
</script>

<style scoped>
.label-attachment {
  font-size: 16px;
  font-weight: 600;
}

.label-name {
  font-size: 16px;
  font-weight: 600;
}

.attachment-box {
  background-color: #ffffff;
  border: 1px solid #9e9e9e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.attachment-box:hover {
  background-color: #eeeeee;
}

::v-deep .v-input__slot {
  max-height: 120px !important;
}

::v-deep .v-text-field__slot {
  overflow-y: auto;
}

::v-deep .v-btn__content {
  display: flex;
  flex-direction: row;
}
</style>
